import React from "react";
import Dashboard from "../../components/Dashboard";
import HeaderDrawer from "../../../common/components/HeaderDrawer";

const DashboardScreen = (props) => {
  return (
    <HeaderDrawer name="Dashboard">
      <Dashboard user={props.user} />
    </HeaderDrawer>
  );
};

export default DashboardScreen;
